import styled from 'styled-components';
import { colors, breakPoints } from '@/styles';

export const Modal = styled.div`
  position: relative;
  background: #fff;
  color: #000;
  /* padding: 2rem; */
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  /* text-align: center; */
  display: flex;
  flex-direction: column;
  /* justify-content: flex-start; */
  /* align-items: center; */
  gap: 1rem; /* Space between elements */
  z-index: 1;
  min-width: 300px;
  max-width: 50vw;
  min-height: 100px;
  /* padding-top: 40px; */

  @media (max-width: ${breakPoints.mobile}) {
    position: fixed;
    border-radius: 0;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    padding: 80px 20px 0;
  }
`;

export const CloseButton = styled.button`
  display: flex;
  max-width: 24px;
  max-height: 24px;
  justify-content: center;
  align-items: center;
  padding: 5px;
  background: ${colors.secondary.lightGray2};
  border: none;
  border-radius: 0.5rem;
  &:hover {
    background: ${colors.secondary.lightGray3};
  }
  transition: background 0.1s ease-in-out;
`;

export const CloseButtonFixed = styled(CloseButton)`
  position: absolute;
  top: 10px;
  right: 10px;
`;

export const Header = styled.div`
  min-height: 42px;
  display: flex;
  align-items: center;
  /* justify-content: center; */
  /* border: 1px dashed red; */
  flex: 0;
  padding: 10px;
  border-radius: 0.5rem 0.5rem 0 0;
`;

export const Body = styled.div`
  /* border: 1px dashed red; */
  flex: 1;
  padding: 10px;
`;

export const Footer = styled.div`
  /* border: 1px dashed red; */
  flex: 0;
  padding: 5px;
`;
